import { colors } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { match } from 'ts-pattern';

import { SavingsFundsRequestDetails } from '@Common/types/bo/b2b/savings_funds_requests';

import { coPaymentStatusChoices } from '@sh4res/bo-common/components/B2bSavingsFundRequests/choices';
import { SelectChipField } from '@sh4res/bo-common/fields';

export const CoPaymentStatus = () => {
  const record = useRecordContext<SavingsFundsRequestDetails>();
  if (!record) {
    return;
  }

  return (
    <SelectChipField
      source="co_payment_status"
      data-testid="BoExternalSavingsFundRequestDetails_CoPaymentStatusField"
      emptyText="-"
      sx={{
        backgroundColor: match(record.co_payment_status)
          .with('settled', 'captured', () => colors.green[500])
          .with(
            'rejected',
            'authorization_declined',
            'pending_declined',
            'card_verification_declined',
            'shares_cancelled',
            () => colors.red[500],
          )
          .with('returned', 'refunded', 'partially_refunded', () => colors.grey[500])
          .with(null, () => colors.grey[300])
          .otherwise(() => colors.deepOrange[500]),
        color: 'white',
      }}
      choices={coPaymentStatusChoices}
    />
  );
};
